import { combineReducers } from "redux";
import userReducer from "../reducers/userReducer";
import bookInvitesReducer from "../reducers/invitesReducer";
import organisationReducer from "../reducers/organisationReducer";
import booksReducer from "redux/reducers/booksReducer";
import snackbarReducer from "shared/redux/reducers/SnackbarReducer";
import { auditTemplateReducer } from "redux/reducers/auditTemplateReducer";
import { configAIReducer } from "redux/reducers/configAiReducer";
import checklistReducer from "containers/checklist/redux/reducers";

export default combineReducers({
    user: userReducer,
    snackbar: snackbarReducer,
    bookInvites: bookInvitesReducer,
    organisation: organisationReducer,
    books: booksReducer,
    auditTemplate: auditTemplateReducer,
    configAI: configAIReducer,
    manageChecklists: checklistReducer
});